export default __webpack_public_path__ + "static/media/talan.955c9a51.png";